<template>
   <div :class="`users users-${blur ? 'blur' : ''} users-${!busy ? 'active' : ''}`">
    <!-- <UsersCategory v-if="person"/> -->
    <UsersList :direction="false"/>
    <UserInfo :person="person"/>
    <UsersList :direction="true"/>
    <Share/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import UsersList from '@/components/Users/List';
import UserInfo from '@/components/Users/Info';
import Share from '@/components/Users/Share';


export default {
  components: {
    UsersList,
    UserInfo,
    Share,
  },

  computed: mapGetters({
    busy: 'personBusy',
    person: 'person',
    blur: 'blur',
  }),
};
</script>

<style>
.users{
  transition: opacity .4s ease-in-out;
  position: absolute;
  text-align: center;
  margin-left: -450%;
  white-space: nowrap;

  width: 1000%;
  z-index: 99;
  opacity: 0;
  bottom: 18%;
  left: 0;

  @media (max-height: 800px) {
    bottom: 10%;
  }

  &-blur{
    .user--list,
    .user--info,
    .share{
      filter: blur(10px);
    }
  }

  &-active{
    opacity: 1;
  }

  @media (min-height: 800px){
    bottom: 11%;
  }

  @media (min-height: 960px){
    bottom: 16%;
  }
}
</style>



// WEBPACK FOOTER //
// Users.vue?29cd97ac